module.exports = __webpack_public_path__ + "assets/img/3-3.61a87f61.png";